import { AI_MODEL_LABELS, RagAiModel } from './RagAiModel';
import { SUMMARISATION_AI_MODEL_LABELS } from './SummarisationAiModel';

export enum HealthScoreAiModel {
  GPT_6_LUNA = 'GPT_6_LUNA',
  CLAUDE_5_5_HAIKU = 'CLAUDE_5_5_HAIKU'
}

// Label suffix shows where the model processes data.
export const HEALTH_SCORE_AI_MODEL_LABELS: Record<HealthScoreAiModel, string> =
  {
    [HealthScoreAiModel.GPT_6_LUNA]: SUMMARISATION_AI_MODEL_LABELS.GPT_6_LUNA,
    [HealthScoreAiModel.CLAUDE_5_5_HAIKU]:
      AI_MODEL_LABELS[RagAiModel.CLAUDE_5_5_HAIKU]
  };
